import {gql} from '@apollo/client';

import {getRegistrySupportedOligoAwareTypesGraphQL} from 'constants/RegistryConstants';
import {OligoAwareFolderItemType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {TagSchemaListingGraphQL} from '../../graphql-fragments/schemas/__generated/TagSchemaListingGraphQL';
import {GetTagSchemasListing, GetTagSchemasListingVariables} from './__generated/GetTagSchemasListing';

export const GET_TAG_SCHEMAS_LISTING_QUERY = gql`
  query GetTagSchemasListing($searchInput: TagSchemaListingSearchInput, $limitOffsetInput: LimitOffsetInput)
  @skipAudit
  @engComponent(name: SCHEMAS) {
    tagSchemasListing(searchInput: $searchInput, limitOffsetInput: $limitOffsetInput) {
      tagSchemas {
        ...TagSchemaListingGraphQL
      }
      total
    }
    starredTagSchemas {
      id
    }
  }
  ${getFragmentWrapper('TagSchemaListing').fragment}
`;

export interface UseTagSchemasListingQueryArgs {
  skip?: boolean;
  registryId?: string | null;
  oligoAwareFolderItemTypes?: Array<OligoAwareFolderItemType> | null;
}

interface UseTagSchemasListingQueryResult {
  tagSchemas: Array<TagSchemaListingGraphQL>;
  starredTagSchemaIds: Array<string>;
}

export function useTagSchemasListingQuery({
  skip,
  registryId,
  oligoAwareFolderItemTypes,
}: UseTagSchemasListingQueryArgs = {}): UseTagSchemasListingQueryResult | null {
  const result = useSkippableBenchlingQuery<GetTagSchemasListing, GetTagSchemasListingVariables>(
    GET_TAG_SCHEMAS_LISTING_QUERY,
    {
      skip,
      variables: {
        searchInput: {
          registryId: registryId ?? null,
          oligoAwareFolderItemTypes:
            oligoAwareFolderItemTypes ?? getRegistrySupportedOligoAwareTypesGraphQL(),
        },
      },
    }
  );

  if (result.type === QueryResultType.SUCCESS) {
    return {
      tagSchemas: result.data.tagSchemasListing.tagSchemas,
      starredTagSchemaIds: result.data.starredTagSchemas.map((schema) => schema.id),
    };
  } else {
    return null;
  }
}
